/* eslint-disable no-underscore-dangle */
import { ISearchParams } from 'types/searchParams';
import { IRule, INewRule } from 'types/rules';
import { IResponse, IResponseWithPagination } from 'types/response';

import axiosInstance from '../axios';

const rules = {
  getRuleById: (id: string) => axiosInstance.get<IResponse<IRule>>(`/rules/${id}`),

  deleteRule: (id: string) => axiosInstance.delete(`/rules/${id}`),

  postNewRule: (newRule: INewRule) => axiosInstance.post<IResponseWithPagination<IRule>>('/rules', newRule),

  editRule: (editedRule: IRule | INewRule, id: string) => axiosInstance.put<IResponseWithPagination<IRule>>(
    `/rules/${id}`,
    editedRule,
  ),

  getRulesByQueryParams: (queryParams: ISearchParams) => axiosInstance.get<IResponseWithPagination<IRule[]>>('/rules', {
    params: queryParams,
  }),
};

export default rules;
